/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AccessionPrefix } from './AccessionPrefix';
import type { Clinic } from './Clinic';
import type { Lab } from './Lab';
import type { LISCase } from './LISCase';
import type { UserName } from './UserName';

export type AccessionWithCreatedCase = {
    readonly id?: number;
    readonly prefix?: AccessionPrefix;
    year: number;
    number: number | null;
    status?: AccessionWithCreatedCase.status;
    readonly clinic?: Clinic;
    readonly lab?: Lab;
    author: UserName;
    ordering_doctor: UserName;
    supervising_physician: UserName;
    screen_assignment: UserName;
    finalize_assignment: UserName;
    active_assignment: UserName;
    patient?: any;
    specimens?: any;
    guarantor?: any;
    insurance?: any;
    completed_at?: string | null;
    readonly created_at?: string;
    readonly updated_at?: string;
    readonly lab_station_id?: number;
    address?: any;
    collected_date?: string | null;
    received_date?: string | null;
    /**
     * case billing type: Global Bill, Client Bill, Cash Pay, or No Bill
     */
    billing_type?: AccessionWithCreatedCase.billing_type | null;
    /**
     * True if the patient is paying cash; i.e. no insurance. Aka self-pay
     */
    self_pay?: boolean;
    /**
     * True if the patient is paying cash with an attestation; i.e. no insurance. Aka self-pay with attestation
     */
    self_pay_with_attestation?: boolean;
    /**
     * True if the patient has an indigent pay agreement.
     */
    indigent?: boolean;
    /**
     * case type: Clinical, Test, Demo, Validation, Consult, TC PC Split, or Historical
     */
    case_type?: AccessionWithCreatedCase.case_type;
    /**
     * True if we're billing for TC (technical component - lab) work, False if someone else bills.
     */
    bill_tc?: boolean;
    /**
     * True if we're billing for PC (professional component - pathologist) work, False if someone else bills.
     */
    bill_pc?: boolean;
    /**
     * A secondary or external accession for the same case from the system that provided the data to WPL, e.g. Poplar, RPA.
     */
    external_accession?: string | null;
    /**
     * EZDerm's order id that, with patient name, matches the case in their system
     */
    external_ezderm_order_id?: string | null;
    /**
     * Non-EZDerm order id for integrations.
     */
    external_order_id?: string | null;
    priority?: AccessionWithCreatedCase.priority;
    readonly grossed_by_external_lab_id?: number;
    readonly billing_type_default?: string;
    readonly bill_tc_default?: string;
    readonly bill_pc_default?: string;
    readonly created_case?: LISCase;
    _meta?: {
        created?: {
            documents?: Array<number>,
            specimens?: Array<number>,
            blocks?: Array<number>,
            slides?: Array<number>,
        },
        updated?: {
            documents?: Array<number>,
            specimens?: Array<number>,
            blocks?: Array<number>,
            slides?: Array<number>,
        },
        cassette_printing_task_id?: number,
    };
}

export namespace AccessionWithCreatedCase {

    export enum status {
        DRAFT = 'draft',
        READY_FOR_GROSSING = 'ready-for-grossing',
        COMPLETED = 'completed',
    }

    /**
     * case billing type: Global Bill, Client Bill, Cash Pay, or No Bill
     */
    export enum billing_type {
        GLOBAL = 'global',
        CLIENT = 'client',
        NONE = 'none',
    }

    /**
     * case type: Clinical, Test, Demo, Validation, Consult, TC PC Split, or Historical
     */
    export enum case_type {
        CLINICAL = 'clinical',
        TEST = 'test',
        DEMO = 'demo',
        VALIDATION = 'validation',
        CONSULT = 'consult',
        CONTROL = 'control',
        TC_PC = 'tc-pc',
        HISTORICAL = 'historical',
    }

    export enum priority {
        RUSH = 'rush',
        STAT = 'stat',
        NORMAL = 'normal',
    }


}
